// @flow
import React from 'react'
import PropTypes from 'prop-types'
import List from '../utilities/list'
// use connected version
// import CardHorizontal from '../cards/card-horizontal'
import CurrentBidCard from '../../services/bid/current-bid-card'
import DropLayer from '../modal/drop-layer'
import { BID_STATE } from '../../services/bid/constants'

const CurrentBids = (props: Object) => (
  <DropLayer
    text={props.title}
    barTheme='dark-bar'
    theme='dark-theme'
    isOpen={props.isOpen}
    onCloseButtonClick={props.onClose}
  >
    {props.isOpen && (
      <List className='card-list desktop-wide-cards'>
        {props.outbidItemBids.map(itemId => (
          <CurrentBidCard
            key={itemId}
            bidState={BID_STATE.OUTBID}
            itemId={itemId}
          />
        ))}
        {props.winningItemBids.map(itemId => (
          <CurrentBidCard
            key={itemId}
            bidState={BID_STATE.WINNING}
            itemId={itemId}
          />
        ))}
      </List>
    )}
  </DropLayer>
)

CurrentBids.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  // array of bid ids
  outbidItemBids: PropTypes.array,
  winningItemBids: PropTypes.array
}

CurrentBids.defaultProps = {
  isOpen: false,
  title: 'My Current Bids',
  outbidItemBids: [],
  winningItemBids: []
}

export default CurrentBids



// WEBPACK FOOTER //
// ./src/ui/views/current-bids.js